import Create from "./Create";

export default {
  create: Create,
};
